<!--
 * @Description: 石模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-30 14:19:51
-->
<template>
    <div id="template6" class="template_table_parent">
        <table class="template_table" border="1" cellpadding="0" cellspacing="0" @click="example">
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>检测编号：</td>
                <td class="bg5" colspan="2"></td>
            </tr>
            <tr>
                <td>委托单位</td>
                <td class="bg5" colspan="2"></td>
                <td>品 种</td>
                <td class="bg5" colspan="2"></td>
                <td>工程名称</td>
                <td class="bg5" colspan="2"></td>
                <td>取样日期</td>
                <td class="bg3 select_date" colspan="2">
                    <el-date-picker
                        v-model="tableData.qysj"
                        format="HH:mm"
                        value-format="timestamp"
                        type="datetime">
                    </el-date-picker>
                </td>
            </tr>
            <tr>
                <td>检测单位</td>
                <td class="bg5" colspan="2"></td>
                <td>规 格</td>
                <td class="bg5" colspan="2"></td>
                <td>环境湿度</td>
                <td class="bg6" colspan="2"></td>
                <td>试验日期</td>
                <td class="bg3 select_date" colspan="2">
                    <el-date-picker
                        v-model="tableData.syDate"
                        format="HH:mm"
                        value-format="timestamp"
                        type="datetime">
                    </el-date-picker>
                </td>
            </tr>
            <tr>
                <td>生产厂家</td>
                <td class="bg5" colspan="2"></td>
                <td>产 地</td>
                <td class="bg5" colspan="2"></td>
                <td>环境温度</td>
                <td class="bg6" colspan="2"></td>
                <td>检验依据</td>
                <td class="bg4" colspan="2"></td>
            </tr>
            <tr>
                <td>进场验收项目</td>
                <td>含泥量（%）</td>
                <td class="bg5 red" colspan="2" attrName="kjhnl" setType="input">{{tableData.kjhnl && tableData.kjhnl.hgbz || '待配置'}}</td>
                <td>泥块含量（%）</td>
                <td class="bg5 red" colspan="2" attrName="kjnkhl" setType="select">{{tableData.kjnkhl && tableData.kjnkhl.hgbz && tableData.kjnkhl.hgbz.label || '待配置'}}</td>
                <td>颗粒级配</td>
                <td class="bg5 red" attrName="kjkljp" setType="select">{{tableData.kjkljp && tableData.kjkljp.hgbz && tableData.kjkljp.hgbz.label || '待配置'}}</td>
                <td>针片状含量（%）</td>
                <td class="bg5 red" attrName="kjzpzhl" setType="input">{{tableData.kjzpzhl && tableData.kjzpzhl.hgbz || '待配置'}}</td>
            </tr>
            <tr>
                <td rowspan="4">堆积密度</td>
                <td rowspan="2">（样+筒）重（g）</td>
                <td rowspan="2">筒重（g）</td>
                <td rowspan="2">筒容积（L）</td>
                <td rowspan="2">密度值（kg/m³）</td>
                <td rowspan="2">平均值（kg/m³）</td>
                <td colspan="6">筛分分析试验</td>
            </tr>
            <tr>
                <td colspan="6">试样重（g）</td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td class="bg1" rowspan="2" attrName="djmdpjz" setType="input">{{tableData.djmdpjz && tableData.djmdpjz.hgbz || '待配置'}}</td>
                <td rowspan="2">筛孔尺寸（mm）</td>
                <td rowspan="2">分计筛余量（g）</td>
                <td rowspan="2" colspan="2">分计筛余百分率（%）</td>
                <td rowspan="2" colspan="2">累计筛余百分率（%）</td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
            </tr>
            <tr>
                <td rowspan="4">表观密度</td>
                <td rowspan="2">样重（g）</td>
                <td rowspan="2">（瓶+水）重（g）</td>
                <td rowspan="2">（样+瓶+水）重（g）</td>
                <td rowspan="2">密度值（kg/m³）</td>
                <td rowspan="2">平均值（kg/m³）</td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td class="bg1" rowspan="2" attrName="bgmdpjz" setType="input">{{tableData.bgmdpjz && tableData.bgmdpjz.hgbz || '待配置'}}</td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td>空隙率（%）</td>
                <td colspan="5"></td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td rowspan="3">含泥量</td>
                <td>洗前干重（g）</td>
                <td>洗后干重（g）</td>
                <td>含泥量（%）</td>
                <td colspan="2">平均值（%）</td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td class="bg1" colspan="2" rowspan="2" attrName="hnlpjz" setType="input">{{tableData.hnlpjz && tableData.hnlpjz.hgbz || '待配置'}}</td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td rowspan="3">泥块含量</td>
                <td>洗前干重（g）</td>
                <td>洗后干重（g）</td>
                <td>泥块含量（%）</td>
                <td colspan="2">平均值（%）</td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td class="bg1" colspan="2" rowspan="2" attrName="nkhlpjz" setType="input">{{tableData.nkhlpjz && tableData.nkhlpjz.hgbz || '待配置'}}</td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td></td>
                <td class="bg3"></td>
                <td colspan="2"></td>
                <td colspan="2"></td>
            </tr>
            <tr>
                <td rowspan="3">针片状颗粒含量</td>
                <td colspan="2" rowspan="2">样重（g）</td>
                <td colspan="2" rowspan="2">（针状+片状）重（g）</td>
                <td rowspan="2">针片状颗粒含量（%）</td>
                <td>最大公称粒径（mm）</td>
                <td colspan="2"></td>
                <td>级配判定</td>
                <td class="bg1" colspan="2" attrName="jppd" setType="select">{{tableData.jppd && tableData.jppd.hgbz && tableData.jppd.hgbz.label || '待配置'}}</td>
            </tr>
            <tr>
                <td>实测规格（mm）</td>
                <td colspan="2"></td>
                <td colspan="3"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
                <td class="bg1" attrName="zpzklhl" setType="input">{{tableData.zpzklhl && tableData.zpzklhl.hgbz || '待配置'}}</td>
                <td rowspan="5">备 注</td>
                <td rowspan="5" colspan="5"></td>
            </tr>
            <tr>
                <td rowspan="4">压碎指标</td>
                <td>样重（g）</td>
                <td>压碎后筛余（g）</td>
                <td>压碎指标（%）</td>
                <td colspan="2">平均值（%）</td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
                <td class="bg1" colspan="2" rowspan="3" attrName="yszbpjz" setType="input">{{tableData.yszbpjz && tableData.yszbpjz.hgbz || '待配置'}}</td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
            </tr>
            <tr>
                <td class="bg3"></td>
                <td class="bg3"></td>
                <td></td>
            </tr>
            <tr>
                <td></td>
                <td>审核：</td>
                <td class="bg5" colspan="2"></td>
                <td></td>
                <td>试验：</td>
                <td class="bg5" colspan="2"></td>
                <td></td>
            </tr>
        </table>

        <SetStandardDialog :visible.sync="setStandardVisible" :config="setStandardConfig" @updated="setData"/>
    </div>
</template>
<script>
import SetStandardDialog from './SetStandardDialog'

const ARR = [
    { key: 'kjhnl', title: '含泥量', category: 7, type: 2, code: 'cell_13' },
    { key: 'kjnkhl', title: '泥块含量', category: 7, type: 1, code: 'cell_14', options: [{ value: 0, label: '目测无' }, { value: 1, label: '目测有' }]},
    { key: 'kjkljp', title: '颗粒级配', category: 7, type: 1, code: 'cell_15', options: [{ value: 0, label: '合格' }, { value: 1, label: '不合格' }]},
    { key: 'kjzpzhl', title: '针片状含量', category: 7, type: 2, code: 'cell_16' },
    { key: 'djmdpjz', title: '堆积密度平均值', category: 1, type: 2, code: 'cell_25' },
    { key: 'bgmdpjz', title: '表观密度平均值', category: 1, type: 2, code: 'cell_34' },
    { key: 'hnlpjz', title: '含泥量平均值', category: 1, type: 2, code: 'cell_42' },
    { key: 'nkhlpjz', title: '泥块含量平均值', category: 1, type: 2, code: 'cell_49' },
    { key: 'zpzklhl', title: '针片状颗粒含量', category: 1, type: 2, code: 'cell_52' },
    { key: 'yszbpjz', title: '压碎指标平均指标', category: 1, type: 2, code: 'cell_62' },
    { key: 'jppd', title: '级配判定', category: 1, type: 1, code: 'cell_98', options: [{ value: 0, label: '合格' }, { value: 1, label: '不合格' }]},
]

export default {
    components: {
        SetStandardDialog, // 设置标准
    },
    props: {
        templateData: {
            type: Object,
            default: () => {},
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            setStandardConfig: {},
            setStandardVisible: false,
            tableData: {},
        }
    },
    created() {
        const obj = {};
        for(let i = 0; i < ARR.length; i++) {
            obj[ARR[i].key] = {}
        }
        this.tableData = obj
        if(this.templateData) {
            this.tableData = this.templateData
        }
    },
    watch: {
        templateData: {
            deep: true,
            handler: function() {
                if(this.templateData) {
                    this.tableData = this.templateData
                } else {
                    const obj = {};
                    for(let i = 0; i < ARR.length; i++) {
                        obj[ARR[i].key] = {}
                    }
                    this.tableData = obj
                }
            },
        },
    },
    methods: {
        // 格式化数据
        fData(data) {
            if(data && data['hgbz']) {
                let type = null;
                if(Array.isArray(data['hgbz'])) type = 'input'
                if(!Array.isArray(data['hgbz'])) type = 'select'
                if(typeof data['hgbz'] === 'string') type = 'popup'
                if(type === 'input') {
                    const arr = ['合格标准', '相邻波动', '异常标准1', '异常标准2'],
                          keys = ['hgbz', 'xlbd', 'ycbz', 'ycbz2'];
                    let res = [], index
                    for (let key in data) {
                        index = keys.indexOf(key)
                        res.push({
                            code: index + 1,
                            iteam: arr[index],
                            min: data[key][0],
                            max: data[key][1],
                            format: index === 0?1:2
                        })
                    }
                    return JSON.stringify(res)
                } else if(type === 'select') {
                    return JSON.stringify({id: data.hgbz.value, value: data.hgbz.label})
                } else if(type === 'popup'){
                    return data.hgbz
                } else {
                    return ''
                }
            } else {
                return ''
            }
            
        },
        example(e) {
            if (this.readOnly) return
            // 事件委托，根据属性判断是否可以点击
            const target = e.target
            const key = target.getAttribute('attrName')
            const type = target.getAttribute('setType')
            if (key && type) {
                this.setStandard(key, type)
            }
        },
        setStandard(key, type) {
            // 设置标准
            // key 要设置的属性名
            // type 类型 input输入框 select下拉框
            if (type === 'input' || type === 'select') {
                this.setStandardConfig = {
                    key,
                    type,
                    data: this.tableData[key],
                }
                if(type === 'select') {
                    this.setStandardConfig.options = ARR.filter(item=>item.key === key)[0].options
                }
                this.setStandardVisible = true
            }
        },
        setData(data) {
            // 自定义事件的回调，设置表格属性
            if (!data.type) return
            this.tableData[data.key] = data.data;

        },
        getData() {
            for(let i = 0; i < ARR.length; i++) {
                if(this.tableData[ARR[i].key] && !this.tableData[ARR[i].key].hgbz) {
                    this.$message.info('请配置' + ARR[i].title);
                    return false;
                }
            }
            const data = {};
            for (let i = 0; i < ARR.length; i++) {
                data[ARR[i].code] = {
                    title: ARR[i].title,
                    category: ARR[i].category,
                    type: ARR[i].type,
                    condition: this.fData(this.tableData[ARR[i].key]),
                    options: ARR[i].options ? JSON.stringify(ARR[i].options.map(item=>({id: item.value, value: item.label}))) : '',
                    resultValue: ''
                }
            }
            // 暴露自身表格数据的方法，父组件通过$refs调用
            return { data, tableData: this.tableData }
        },
    },
}
</script>
<style lang="scss" scoped>
#template1 {
    width: 1200px;
}
$td_width: 100px;
$td_height: 36px;
.params_template {
    width: 100%;
    margin-top: 20px;
    .top {
        display: flex;
        margin-left: 20px;
        .params_type {
            flex: 1;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .item {
                width: 33%;
                margin-bottom: 16px;
                display: flex;
                .item_color {
                    width: 28px;
                    height: 22px;
                    margin-right: 10px;
                }
                .item_text {
                    font-weight: 400;
                }
            }
        }
        .btn {
            width: 350px;
        }
    }
    .template_content {
        width: 100%;
        height: 430px;
        overflow: auto;
    }
    .text {
        width: 100%;
        height: 500px;
        color: #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .template_table_parent {
        margin: 0 30px 20px 20px;
        table {
            border-collapse: collapse;
            border: 0 !important;
        }
        td {
            position: relative;
        }
        table,th,td{
            border: 1px solid black;
        }
        .el-date-table {
            table,th,td{
                border: 0;
            }
        }
        .bg1 { // 必检
            background: #ffff00;
            color: red;
            cursor: pointer;
        }
        .bg2 { // 选检
            background: #ffffcd;
            color: red;
            cursor: pointer;
        }
        .bg3 { // 必填
            background: #00b14b;
        }
        .bg4 { // 默认
            background: #8062a4;
        }
        .bg5 { // 系统带入
            background: #fdd5b2;
        }
        .bg6 { // 选填
            background: #90d246;
        }
        .text_color { // 业务数据及系统带入值默认颜色
            color: #777;
        }
        .red { // 配置项颜色
            color: red;
            cursor: pointer;
        }
        .template_table {
            .el-select__caret { // 下拉框的下拉箭头
                display: none;
            }
            .el-textarea__inner { // 文本域设置
                width: 100%;
                height: 100%;
                line-height: 36px;
                border: 0;
                outline: none;
                resize: none;
            }
            .el-input {
                width: 100%;
                text-align: center;
            }
            .el-input__inner {
                width: 100%;
                border: 0;
                border-radius: 0;
                background: transparent;
                color: #000;
                text-align: center;
            }
            .el-input__suffix {
                color: #000
            }
            input::-webkit-input-placeholder{
                color: #000;
            }
            .select_date {
                .el-input__inner {
                    width: 100%;
                    border: 0;
                    border-radius: 0;
                    background: transparent;
                    color: #000;
                    padding: 0 10px;
                    text-align: center;
                }
                .el-input__prefix {
                    display: none;
                }
            }
            tr:first-child, tr:last-child{
                td {
                    border: 0;
                }
            }
            td {
                width: $td_width;
                height: $td_height;
                text-align: center;
            }
        }
    }
    
}
</style>